"use strict";function n(a,e){for(var i=a<0?"-":"",t=Math.abs(a).toString();t.length<e;)t="0"+t;return i+t}exports.addLeadingZeros=n;
